import { salesforceLink, type SfObject } from "../lib/salesforceLink";

interface SalesforceDeepLinkProps {
  sfId: string;
  objectType: SfObject;
  label?: string;
  className?: string;
  /** Stops parent row click when used inside ResultsTable rows. */
  stopPropagation?: boolean;
}

export function SalesforceDeepLink({
  sfId,
  objectType,
  label,
  className = "sf-link",
  stopPropagation = true,
}: SalesforceDeepLinkProps) {
  return (
    <a
      href={salesforceLink(objectType, sfId)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label={label ?? `Open ${objectType} in Salesforce (new tab)`}
      title="Open in Salesforce (new tab)"
      onClick={(e) => {
        if (stopPropagation) e.stopPropagation();
      }}
    >
      ↗
    </a>
  );
}
